// extracted by mini-css-extract-plugin
export var modal = "_fa-0";